
import placeType from '../../../../../data/placetype.json';



export function getFreePlacesInfo(group) {
    const { placesAmount } = group;
    const usesPlaces = {};
    const freePlaces = {};
    const places_amount = {};

    // Инициализируем все счетчики нулями для всех типов мест
    for (let key in placeType.translate) {
        usesPlaces[key] = 0;
        freePlaces[key] = 0;
        places_amount[key] = 0;
    }

    // Считаем занятые места (только активные дети)
    for (let ch of group.children) {
        if (!ch.dateTo || (new Date(ch.dateTo) > new Date())) {
            usesPlaces[ch.placeType] += 1;
        }
    }

    let aval = 0;

    // Сначала проходим по всем типам и суммируем места для каждого типа группы
    for (let key in placeType.placeamount) {
        const keyPlaceGroup = placeType.placeamount[key];
        
        if (placesAmount[key] !== undefined && placesAmount[key] !== null) {
            // СУММИРУЕМ места для каждого типа группы, а не перезаписываем
            places_amount[keyPlaceGroup] += placesAmount[key];
        }
    }

    // Затем считаем свободные места
    for (let key in places_amount) {
        const totalPlaces = places_amount[key];
        const usedPlaces = usesPlaces[key] || 0;
        const diffCount = totalPlaces - usedPlaces;
        
        freePlaces[key] = diffCount > 0 ? diffCount : 0;
        if (diffCount > 0) aval += 1;
    }

    return { places_amount, uses_places: usesPlaces, free_places: freePlaces, aval };
}


export function getFreePlacesInfo_old(group){
    const { placesAmount } = group;
    const usesPlaces = {}

    for(let key in placeType.translate){ usesPlaces[key] = 0;}

    const freePlaces = Object.assign({}, usesPlaces);

    const places_amount = Object.assign({}, usesPlaces);

    for(let ch of group.children){
        if(!ch.dateTo || ( new Date(ch.dateTo) > new Date() ) ) usesPlaces[ch.placeType] += 1;
    }

    let aval = 0;

    


    for(let key in placeType.placeamount){

        const keyPlaceGroup = placeType.placeamount[key];

        if(!placesAmount[key] || !usesPlaces[keyPlaceGroup]) continue;

        const diffCount = placesAmount[key] - usesPlaces[keyPlaceGroup];

        freePlaces[keyPlaceGroup] =  diffCount > 0 ? diffCount : 0;

        if(diffCount > 0) aval += 1;

        places_amount[keyPlaceGroup] = placesAmount[key];

    }

    return ({places_amount, uses_places: usesPlaces, free_places: freePlaces, aval});


}